import type { SignUpRequest } from '@/types';

import React from 'react';

import { deleteCookie, getCookie } from '@/utils';

const useGetExclusiveLink = ({
  setSignUpData,
  enabled,
  dependencies,
}: {
  setSignUpData: React.Dispatch<React.SetStateAction<Partial<SignUpRequest>>>;
  enabled: boolean;
  dependencies: any[];
}): void => {
  React.useEffect(() => {
    if (enabled) {
      getCookie({ name: 'user_id' })
        .then(async (response) => {
          if (response?.value) {
            setSignUpData((prev) => ({
              ...prev,
              parent_id: parseInt(response?.value),
              registration_type: 'agent_id',
              hasReferralCode: true,
            }));
            await deleteCookie({ name: 'user_id' });
          }
          return {};
        })
        .catch(() => '');
    }
  }, [dependencies]);
};

export default useGetExclusiveLink;
